// 简单的路由工具，替代vue-router
import { ref } from 'vue'

// 初始化路由状态，正确解析查询参数
const initRoute = () => {
  const hash = window.location.hash.replace('#', '') || '/pages/index/index'
  const path = hash.split('?')[0]
  const queryString = hash.split('?')[1]
  
  const query = {}
  if (queryString) {
    queryString.split('&').forEach(param => {
      const [key, value] = param.split('=')
      query[key] = decodeURIComponent(value || '')
    })
  }
  
  console.log('Router init - hash:', hash);
  console.log('Router init - path:', path);
  console.log('Router init - query:', query);
  
  return {
    path: path,
    params: {},
    query: query
  }
}

const currentRoute = ref(initRoute())

// 模拟router实例
export const router = {
  currentRoute,
  
  push(to) {
    console.log('Router.push called with:', to);
    if (typeof to === 'string') {
      console.log('跳转到路径:', to);
      currentRoute.value.path = to
      window.location.hash = to
    } else if (to.path) {
      console.log('跳转到路径:', to.path);
      currentRoute.value.path = to.path
      window.location.hash = to.path
    }
    
    // 触发导航
    if (window.navigateTo) {
      console.log('调用window.navigateTo:', currentRoute.value.path);
      window.navigateTo(currentRoute.value.path)
    } else {
      console.log('window.navigateTo不存在');
    }
  },
  
  replace(to) {
    this.push(to)
  },
  
  go(delta) {
    if (delta < 0) {
      window.history.back()
    } else if (delta > 0) {
      window.history.forward()
    }
  },
  
  back() {
    window.history.back()
  },
  
  forward() {
    window.history.forward()
  }
}

// 模拟useRouter hook
export function useRouter() {
  return router
}

// 模拟useRoute hook
export function useRoute() {
  return currentRoute
}

// 监听hash变化更新当前路由
window.addEventListener('hashchange', () => {
  const newHash = window.location.hash.replace('#', '') || '/pages/index/index'
  const newPath = newHash.split('?')[0] // 分离路径和查询参数
  console.log('Router: hash changed to:', newHash);
  console.log('Router: path part:', newPath);
  
  currentRoute.value.path = newPath
  
  // 解析查询参数
  const queryString = newHash.split('?')[1]
  if (queryString) {
    const query = {}
    queryString.split('&').forEach(param => {
      const [key, value] = param.split('=')
      query[key] = decodeURIComponent(value || '')
    })
    currentRoute.value.query = query
    console.log('Router: parsed query:', query);
  } else {
    currentRoute.value.query = {}
  }
})

export default router
